<script>
export default {
  inheritAttrs: false
}
</script>
<script setup>
const props = defineProps({
  gray: Boolean,
  withBorderTop: Boolean,
  noPaddings: Boolean,
  noOuterPaddings: Boolean,
  outerPadding: String,
  withBorderBottomRounded: String,
  customBackground: String,
  customPosition: String,
  darkColor: {
    type: Boolean,
    default: false
  },
  fullHeight: {
    type: Boolean,
    default: false
  }
  
})
</script>

<template>
  <div class="w-full" :class="{'bg-gray-200': gray, 'h-full': fullHeight,'dark:bg-gray-700':darkColor} ">
    <div class="mx-auto container min-w-80 transition-[max-width]" :class="{'h-full': fullHeight}">
      <div :class="[
        {
          'h-full': fullHeight,
          'px-4 sm:px-8': !props.noOuterPaddings && !props.outerPadding,
          [props.outerPadding]: props.outerPadding,
          [props.customBackground]: props.customBackground,
          [props.withBorderBottomRounded]: props.withBorderBottomRounded,
          [props.customPosition]: props.customPosition
        }
      ]">
        <div v-if="withBorderTop" class="border-t border-t-gray-400"></div>
        <div :class="[$attrs.class,{'pt-12 pb-12':!noPaddings}]">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
